import { useState } from 'react';
import { Plus, X } from 'lucide-react';

export interface FaqItem {
	question: string;
	answer: string;
}

interface FaqAccordionProps {
	items: FaqItem[];
	/** Index open on first paint (-1 for all collapsed). */
	defaultOpen?: number;
}

export default function FaqAccordion({ items, defaultOpen = 0 }: FaqAccordionProps) {
	const [open, setOpen] = useState(defaultOpen);

	return (
		<div className="flex flex-col gap-3">
			{items.map((item, i) => {
				const isOpen = open === i;
				return (
					<div
						key={`${item.question}-${i}`}
						data-open={isOpen}
						className="lp-faq-item lp-card overflow-hidden"
					>
						<h3 className="lp-h4">
							<button
								type="button"
								onClick={() => setOpen(isOpen ? -1 : i)}
								aria-expanded={isOpen}
								className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
							>
								<span className="text-white">{item.question}</span>
								<span className="lp-faq-toggle" aria-hidden>
									{isOpen ? <X className="h-3.5 w-3.5" /> : <Plus className="h-3.5 w-3.5" />}
								</span>
							</button>
						</h3>

						{isOpen && (
							<p className="-mt-1 max-w-[52ch] px-5 pb-5 text-sm leading-relaxed text-white/[0.55]">
								{item.answer}
							</p>
						)}
					</div>
				);
			})}
		</div>
	);
}
